import React from 'react';
import HeaderTeamLogo from '../components/HeaderTeamLogo';
import { useTeams } from '../hooks/team';

export default function HeaderTeamLogos() {
  const [teams] = useTeams();

  if (teams) {
    return (
      <div className="team-bar">
        <div className="site-container team-bar__container">
          {teams.map((team) => (
            <HeaderTeamLogo key={team.abbrv} team={team} />
          ))}
        </div>
      </div>
    );
  }
}
